import { heicTo } from 'heic-to';
import authApi from '../authApi';

export const getFileFromS3 = async (url, name) => {
  if (!url?.includes('blob:')) {
    const res = await authApi.get(`v2/file-from-s3?url=${url}&name=${name}`, {
      responseType: 'blob',
    });

    const blob = new Blob([res.data], { type: res.headers['content-type'] });
    const file = new File([blob], `${name}.png`, { type: blob.type });
    return file;
  }
};

export const heicToJpgFromS3 = async (url, name = 'temp') => {
  if (!url?.includes('blob:')) {
    const res = await authApi.get(`v2/file-from-s3?url=${url}&name=${encodeURIComponent(name)}`, {
      responseType: 'blob',
    });

    const blob = new Blob([res.data], { type: res.headers['content-type'] });

    const isHeic =
      blob?.type === 'image/heic' ||
      blob?.type === 'image/heif' ||
      url?.toLowerCase().endsWith('.heic') ||
      url?.toLowerCase().endsWith('.heif');

    if (isHeic) {
      try {
        const jpegBlob = await heicTo({
          blob: blob,
          toType: 'image/jpeg',
          quality: 0.3,
        });

        const convertUrl = URL.createObjectURL(jpegBlob);
        return convertUrl;
      } catch (e) {
        console.error('HEIC conversion error:', e);
        return url;
      }
    } else return url;
  }
};

export const fileDownloadFromS3 = async (url, name = 'file') => {
  if (!url?.includes('blob:')) {
    const res = await authApi.get(`v2/file-from-s3?url=${url}&name=${encodeURIComponent(name)}`, {
      responseType: 'blob',
    });

    const blob = new Blob([res.data], { type: res.headers['content-type'] });

    const fileName = url?.split('/')?.at(-1) || 'file';

    const file = new File([blob], fileName, { type: blob.type });

    const fileUrl = URL.createObjectURL(file);

    let a = document.createElement('a');
    a.href = fileUrl;
    a.download = fileName;

    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);
  }
};
